import { PreferredApp } from '../types';
import { isDevMode } from './dev';
import qs from 'query-string'

const BRANCH_DOMAIN_PROD: Record<PreferredApp, { domain: string }> = {
  WixOneApp: { domain: 'j4z6.app.link' },
  WixFitnessApp: { domain: 's2jch.app.link' },
  WixRestaurantsApp: { domain: '1ov5b.app.link' },
  WixAdminApp: { domain: 'vgal2.app.link' },
  WixBrandedApp: { domain: 'j4z6.app.link' },
};

const BRANCH_DOMAIN_DEV: Record<PreferredApp, { domain: string }> = {
  WixOneApp: { domain: 'j4z6.test-app.link' },
  WixFitnessApp: { domain: 's2jch.test-app.link' },
  WixRestaurantsApp: { domain: '1ov5b.test-app.link' },
  WixAdminApp: { domain: 'vgal2.test-app.link' },
  WixBrandedApp: { domain: 'j4z6.app.link' },
};

export function branchUrlFactory(appType: PreferredApp) {
  return isDevMode()
    ? factory(BRANCH_DOMAIN_DEV[appType])
    : factory(BRANCH_DOMAIN_PROD[appType]);
}

function factory({ domain }: { domain: string }) {
  domain = encodeURIComponent(domain);

  return (link: string, queryParams = {}) => {
    const queryParamsString = qs.stringify(queryParams, {encode: false} );
    const linkQueryParams = queryParamsString ? `/?${queryParamsString}` : '';
    const inviteLink = encodeURIComponent(`${link}${linkQueryParams}`);
    return `https://${domain}/?link=${inviteLink}`;
  };
}
